export function getUserId() {
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));
  return userDetail.IdUsuario;
}

export function getUserName() {
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));
  return userDetail.Nome;
}

export function getUserEmail() {
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));
  return userDetail.Email;
}
